function _removeFromStorage(name) {
	localStorage.removeItem(name);
	localStorage.removeItem(`${name}_expiresIn`);
}

export function getInStorage(key) {
	let expiresIn = localStorage.getItem(`${key}_expiresIn`) || 0;

	if (expiresIn < Date.now()) {
		_removeFromStorage(key);
		return Promise.reject();
	} else {
		const json = localStorage.getItem(key);
		const value = JSON.parse(json);
		return Promise.resolve(value);
	}
}

export function setInStorage(key, value, expires) {
	if (expires === undefined || expires === null)
		expires = (24 * 60 * 60);
	else
		expires = Math.abs(expires);

	let now = Date.now();
	let schedule = now + expires * 1000;

	localStorage.setItem(key, JSON.stringify(value));
	localStorage.setItem(`${key}_expiresIn`, schedule);
}
